var React = require('react');

function Index (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"12","x":"11","width":"25","height":"2.5","style":{"fill":"#fff"},"key":0}),React.createElement("rect",{"y":"21","x":"11","width":"14","height":"2.5","style":{"fill":"#fff"},"key":1}),React.createElement("rect",{"y":"30","x":"11","width":"18","height":"2.5","style":{"fill":"#fff"},"key":2})]);
}

Index.defaultProps = {"width":"44px","height":"44px","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 44 44"};

module.exports = Index;

Index.default = Index;
